import { createContext } from 'react';

import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { Formatter } from '../../core/types/formatter.js';

export const GaugeChartFormatterContext = createContext<
  Formatter | FormatOptions<Unit, ConvertibleUnit> | undefined
>(undefined);
